module.exports = __webpack_public_path__ + "img/var_03_circle1.99fc5c8e.svg";